import { createFileRoute } from '@tanstack/react-router';
import { PublicEventsPage } from '../../features/community';

export const Route = createFileRoute('/_public/events/')({ component: PublicEventsPage });
